module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/Crl8GalleryView-98336eec08847459b1a226dc5a0e8222.png";